const migrations = {
    80: async () => {
        // resets scanner grid column preferences due to changes in columns
        localStorage.removeItem('scanner-grid-visible-columns');
        localStorage.removeItem('scanner-grid-column-order');
    }
};

const LAST_MIGRATION_STORAGE_KEY = 'last-migration-build-number';

// runs pending migrations once based on the last stored build number.
export async function runMigrations() {
    const lastBuild = Number(localStorage.getItem(LAST_MIGRATION_STORAGE_KEY)) || 0;

    const pendingMigrations = Object.keys(migrations)
        .map(Number)
        .filter(build => build > lastBuild)
        .sort((a, b) => a - b);

    for (const build of pendingMigrations) {
        try {
            await migrations[build]();
        } catch (err) {
            console.error(`Migration failed for build ${build}`, err);
        } finally {
            localStorage.setItem(LAST_MIGRATION_STORAGE_KEY, build);
        }
    }
}
